module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/buyer-consultancy.197f0c1676f637dfee1d50cbc693208b.jpg";